import React from 'react'
import { Link as GatsbyLink } from 'gatsby'
import styled from 'styled-components'
import theme from './theme.js'
import useApp from './use-app-context.js'

function getPathId(path) {
  if (!path) return

  const regex = /^\/([a-f0-9]{10,64})$/i
  const match = path.match(regex)
  return match ? match[1] : null
}

const UnstyledLink = ({
  children,
  className,
  entry,
  href,
  to,
  url,
  onClick
}) => {
  const externalLink = href || url 
  const app = useApp()

  if (onClick) {
    const props = {
      className,
      onClick
    }

    return <ActionLink {...props}>{children}</ActionLink>
  }
  
  if (externalLink) {
    const props = {
      className,
      href: externalLink,
      target: '_blank'
    }

    if (url.charAt(0) === '#') props.target = null

    return <a {...props}>{children}</a>
  }

  to = to ? to : (entry ? entry.path : null)

  const props = {
    className
  }

  if (to) props.to = to

  return (
    <GatsbyLink {...props}>
      {children}
    </GatsbyLink>
  )
}

export const linkStyles = `
  color: ${theme.color.grey.darkest};
  cursor: pointer;
  font-family: underlined;

  &:hover {
    opacity: .6;
  }
`

const ActionLink = styled.span`
  ${linkStyles}
`

const Link = styled(UnstyledLink)`
  color: ${theme.color.grey.darkest};
`

export default Link